export default "__VITE_ASSET__4dQB4vfG__"